// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.list_pMFsH {
  overflow-y:auto;
  flex : 1;
}

.listItem_yMYo4 {
  padding : 5px 10px;
  cursor: pointer;
}
.listItem_yMYo4:hover {
  background-color: #eeeeee;
}

.listItem_yMYo4.selected_x_Aok {
  background-color: #dbdef5;
}

.listItemArea_SCBVp {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding:10px;
  position: relative;

}
.listItemArea_SCBVp:before {
  background: #F4F6FA;
  content:'';
  display:inline-block;
  height: 2px;
  left: 10px;
  right:10px;
  bottom:-5px;
  position: absolute;
}

.listItemTitleArea_KY28r {
  flex-grow: 2
}

.listItemTitle_VYe_O {
  color : #39393E;/*black;*/
  /*font-family: Montserrat, helvetica, sans-serif;*/
  font-size:16px;
  line-height: 19px;
  font-weight: normal;
}

.listItemSubtitle_jv3YV {
  font-size:12px;
  font-weight: normal;
  color : #39393E;
  /*font-family: Montserrat, helvetica, sans-serif;*/
  font-weight: 300;
  line-height: 17px;
}


/*
.textInput {
  padding-left : 5px;
  padding-right : 5px;
  border-top-width : 0;
  border-left-width : 0;
  border-right-width : 0;
  border-bottom: solid 3px rgba(0,0,0,0.05);
  border-radius : 0;
  font-weight: 300;
  font-size:16px;
}

.textInput:focus {
  border-bottom-color: rgba(0,0,128,1.0);
  outline-width: 0;
}

.textInput.error {
    border-bottom-color: rgba(196,0,0,1.0);
}


.labelGroup {
  display: flex;
  flex-direction: row;
  margin: 10px 0;
  align-items: center;
  position:relative;
}

.labelGroup.vertical {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

}

.labelGroup > * {
  flex-grow:1;
}
.labelGroup > label { 
  font-size:13px;
  margin : 5px 5px 5px 0;
  flex-grow: 0;
}


.section > * {
  margin-left : 10px;
  margin-right : 10px;
}

.sectionHeader, .sectionTitleHeader {
  margin-left:0;
  margin-right:0;
  font-size:14px;
  font-weight: 300;
  padding: 5px 10px 5px 10px;
  background-color: #6A6BE1;
  color:rgba(255,255,255,0.75);
}



.sectionTitleHeader {
  font-size:16px;
  font-weight: bold;
  color : white;
  padding:5px 10px 5px 10px;
}

.sectionSubHeader {
  margin-left:0;
  margin-right:0;
  margin-bottom:-5px;
  font-size:14px;
  font-weight: 300;
  padding: 5px 10px 0 10px;
  background-color: #6A6BE1;
  color:rgba(255,255,255,0.75);
}
*/
.insetSection_s1h1Q {
  border-left: 1px solid #6A6BE1;
  padding-left: 20px;
  position:relative;
  max-width:95%;
}


.warningPanel_ppkFZ {
  /* background-image: linear-gradient(90deg, #7e32df, #6a42f0 66%, #2d52c7); */
  background-color: #3A37D7;  
  background-size: cover,auto;
  background-position-y : -60px,0;
  min-height:300px;
  position: relative;
  margin : 20px auto;
  width : 75%;
  box-shadow: 0 5px 20px rgba( 0, 0, 0, 0.05 );
  border: 1px solid #eee;
  text-align: center;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.rest_cZnYL {
  margin-left: 64px;
  display : flex;
  flex-direction: column;
}

.warningImage_Fbfg5 {
  height:250px;
  width:250px;
  margin-left: 64px;
}

.warningCode_l6EVa {
  position: absolute;
  padding:0;
  line-height: 80px;
  top:20px;
  right:20px;
  font-size: 80px;
  color : rgba( 255, 255, 255, 0.25);
}

.warningTitle_WZcvW {
  margin-top:20px;
  font-size : 36px;
  font-weight: bolder;
  color : white;
}

.warningSubtitle_iMU2Q {
  font-size : 18px;
  font-weight: normal;
  color : white;
}


.warningMessage_u0Q1q {
  font-size : 14px;
  font-weight: lighter;
  color : rgba(255,255,255,0.75);
}


.splitPane_LwTqY {
  position: relative;
  display : flex;
  flex-direction: row;
  justify-content: space-between;
}

.splitPaneLeft_Fq5OK {
  position:relative;
  flex-grow: 1;
  height : 100%;/*
  border-top: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;*/

}


.splitPaneRight_QxTa7 {
  position:relative;
  /*width : 360px;*/
  height : 100%;
  /*border-top: 1px solid #eeeeee;*/
}

.card_GvAD3 {
  position : relative;
  display: inline-block;
  padding : 10px;
  margin :10px;
  border : 1px solid #eeeeee;
}

.cardTitle_pV2o0 {
  font : 14px;
  font-weight: bolder;
  color : black;
}
.cardSubtitle_zoOOX {
  font : 12px;
  font-weight: thin;
  color : #555;
}

.cardFooter_zLnzt {
  font : 12px;
  font-weight: thin;
  color : #555;
}


.flag_lXatf {
  margin-top: 5px;
}

.projectIcon_vK6Af {
  width: 24px;
  height: 24px;
}

.projectIcon_vK6Af .image_plXay {
  width: 100%;
  height: 100%;
}

.setIconPopup_QbXgP {
  overflow: visible !important;
  max-width: 200px;
}`, "",{"version":3,"sources":["webpack://./src/views/style.css"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;;AAEpB;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE,eAAe,CAAC,SAAS;EACzB,kDAAkD;EAClD,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAkFC;AACD;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;;AAGA;EACE,6EAA6E;EAC7E,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,4CAA4C;EAC5C,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;;AAGA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;AAChC;;;AAGA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa,CAAC;;;oCAGoB;;AAEpC;;;AAGA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB","sourcesContent":["\n.list {\n  overflow-y:auto;\n  flex : 1;\n}\n\n.listItem {\n  padding : 5px 10px;\n  cursor: pointer;\n}\n.listItem:hover {\n  background-color: #eeeeee;\n}\n\n.listItem.selected {\n  background-color: #dbdef5;\n}\n\n.listItemArea {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding:10px;\n  position: relative;\n\n}\n.listItemArea:before {\n  background: #F4F6FA;\n  content:'';\n  display:inline-block;\n  height: 2px;\n  left: 10px;\n  right:10px;\n  bottom:-5px;\n  position: absolute;\n}\n\n.listItemTitleArea {\n  flex-grow: 2\n}\n\n.listItemTitle {\n  color : #39393E;/*black;*/\n  /*font-family: Montserrat, helvetica, sans-serif;*/\n  font-size:16px;\n  line-height: 19px;\n  font-weight: normal;\n}\n\n.listItemSubtitle {\n  font-size:12px;\n  font-weight: normal;\n  color : #39393E;\n  /*font-family: Montserrat, helvetica, sans-serif;*/\n  font-weight: 300;\n  line-height: 17px;\n}\n\n\n/*\n.textInput {\n  padding-left : 5px;\n  padding-right : 5px;\n  border-top-width : 0;\n  border-left-width : 0;\n  border-right-width : 0;\n  border-bottom: solid 3px rgba(0,0,0,0.05);\n  border-radius : 0;\n  font-weight: 300;\n  font-size:16px;\n}\n\n.textInput:focus {\n  border-bottom-color: rgba(0,0,128,1.0);\n  outline-width: 0;\n}\n\n.textInput.error {\n    border-bottom-color: rgba(196,0,0,1.0);\n}\n\n\n.labelGroup {\n  display: flex;\n  flex-direction: row;\n  margin: 10px 0;\n  align-items: center;\n  position:relative;\n}\n\n.labelGroup.vertical {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n}\n\n.labelGroup > * {\n  flex-grow:1;\n}\n.labelGroup > label { \n  font-size:13px;\n  margin : 5px 5px 5px 0;\n  flex-grow: 0;\n}\n\n\n.section > * {\n  margin-left : 10px;\n  margin-right : 10px;\n}\n\n.sectionHeader, .sectionTitleHeader {\n  margin-left:0;\n  margin-right:0;\n  font-size:14px;\n  font-weight: 300;\n  padding: 5px 10px 5px 10px;\n  background-color: #6A6BE1;\n  color:rgba(255,255,255,0.75);\n}\n\n\n\n.sectionTitleHeader {\n  font-size:16px;\n  font-weight: bold;\n  color : white;\n  padding:5px 10px 5px 10px;\n}\n\n.sectionSubHeader {\n  margin-left:0;\n  margin-right:0;\n  margin-bottom:-5px;\n  font-size:14px;\n  font-weight: 300;\n  padding: 5px 10px 0 10px;\n  background-color: #6A6BE1;\n  color:rgba(255,255,255,0.75);\n}\n*/\n.insetSection {\n  border-left: 1px solid #6A6BE1;\n  padding-left: 20px;\n  position:relative;\n  max-width:95%;\n}\n\n\n.warningPanel {\n  /* background-image: linear-gradient(90deg, #7e32df, #6a42f0 66%, #2d52c7); */\n  background-color: #3A37D7;  \n  background-size: cover,auto;\n  background-position-y : -60px,0;\n  min-height:300px;\n  position: relative;\n  margin : 20px auto;\n  width : 75%;\n  box-shadow: 0 5px 20px rgba( 0, 0, 0, 0.05 );\n  border: 1px solid #eee;\n  text-align: center;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.rest {\n  margin-left: 64px;\n  display : flex;\n  flex-direction: column;\n}\n\n.warningImage {\n  height:250px;\n  width:250px;\n  margin-left: 64px;\n}\n\n.warningCode {\n  position: absolute;\n  padding:0;\n  line-height: 80px;\n  top:20px;\n  right:20px;\n  font-size: 80px;\n  color : rgba( 255, 255, 255, 0.25);\n}\n\n.warningTitle {\n  margin-top:20px;\n  font-size : 36px;\n  font-weight: bolder;\n  color : white;\n}\n\n.warningSubtitle {\n  font-size : 18px;\n  font-weight: normal;\n  color : white;\n}\n\n\n.warningMessage {\n  font-size : 14px;\n  font-weight: lighter;\n  color : rgba(255,255,255,0.75);\n}\n\n\n.splitPane {\n  position: relative;\n  display : flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.splitPaneLeft {\n  position:relative;\n  flex-grow: 1;\n  height : 100%;/*\n  border-top: 1px solid #eeeeee;\n  border-right: 1px solid #eeeeee;\n  border-bottom: 1px solid #eeeeee;*/\n\n}\n\n\n.splitPaneRight {\n  position:relative;\n  /*width : 360px;*/\n  height : 100%;\n  /*border-top: 1px solid #eeeeee;*/\n}\n\n.card {\n  position : relative;\n  display: inline-block;\n  padding : 10px;\n  margin :10px;\n  border : 1px solid #eeeeee;\n}\n\n.cardTitle {\n  font : 14px;\n  font-weight: bolder;\n  color : black;\n}\n.cardSubtitle {\n  font : 12px;\n  font-weight: thin;\n  color : #555;\n}\n\n.cardFooter {\n  font : 12px;\n  font-weight: thin;\n  color : #555;\n}\n\n\n.flag {\n  margin-top: 5px;\n}\n\n.projectIcon {\n  width: 24px;\n  height: 24px;\n}\n\n.projectIcon .image {\n  width: 100%;\n  height: 100%;\n}\n\n.setIconPopup {\n  overflow: visible !important;\n  max-width: 200px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `list_pMFsH`,
	"listItem": `listItem_yMYo4`,
	"selected": `selected_x_Aok`,
	"listItemArea": `listItemArea_SCBVp`,
	"listItemTitleArea": `listItemTitleArea_KY28r`,
	"listItemTitle": `listItemTitle_VYe_O`,
	"listItemSubtitle": `listItemSubtitle_jv3YV`,
	"insetSection": `insetSection_s1h1Q`,
	"warningPanel": `warningPanel_ppkFZ`,
	"rest": `rest_cZnYL`,
	"warningImage": `warningImage_Fbfg5`,
	"warningCode": `warningCode_l6EVa`,
	"warningTitle": `warningTitle_WZcvW`,
	"warningSubtitle": `warningSubtitle_iMU2Q`,
	"warningMessage": `warningMessage_u0Q1q`,
	"splitPane": `splitPane_LwTqY`,
	"splitPaneLeft": `splitPaneLeft_Fq5OK`,
	"splitPaneRight": `splitPaneRight_QxTa7`,
	"card": `card_GvAD3`,
	"cardTitle": `cardTitle_pV2o0`,
	"cardSubtitle": `cardSubtitle_zoOOX`,
	"cardFooter": `cardFooter_zLnzt`,
	"flag": `flag_lXatf`,
	"projectIcon": `projectIcon_vK6Af`,
	"image": `image_plXay`,
	"setIconPopup": `setIconPopup_QbXgP`
};
export default ___CSS_LOADER_EXPORT___;
